import { slugs } from '@/constants/slugs'
import type { Downloadable } from '@/services/DownloadablesService'
import type { VideoMetaData } from '@/services/ProjectsService/types'
import { Media } from '@/utils/EpisodeUtil'

export function hasLivestreamsAvailable(params: { livestreams?: unknown }): boolean {
  const { livestreams } = params
  if (Array.isArray(livestreams)) return livestreams.length > 0
  if (typeof livestreams === 'number') return livestreams > 0
  return false
}

export function hasBonusVideosAvailable(params: { videos?: VideoMetaData[]; movieSpecialMedias: Media[] }): boolean {
  const { videos, movieSpecialMedias } = params

  const hasAdditionalMedias = Array.isArray(movieSpecialMedias) && movieSpecialMedias.length > 0
  const hasBonusVideos = Array.isArray(videos) && videos.length > 0
  return hasAdditionalMedias || hasBonusVideos
}

export function hasMerchItemsAvailable(params: {
  hasShopifyConfig?: boolean
  storeUrl?: string
  accessToken?: string
  handle?: string
  storeHref?: string
}): boolean {
  const { hasShopifyConfig, storeUrl, accessToken, handle, storeHref } = params
  return Boolean(hasShopifyConfig && storeUrl && accessToken && handle && storeHref)
}

export function hasDownloadablesAvailable(downloadables?: Downloadable[]): boolean {
  return Array.isArray(downloadables) && downloadables.length > 0
}

export function normalizeProjectSlug(slug: string): string {
  if (slug === slugs.homesteadSeries || slug === slugs.homesteadFamilySurvival) return slugs.homestead
  if (slug === slugs.riotAndTheDanceSeries) return slugs.riot
  if (slug === slugs.tuttleTwinsMinisodes) return slugs.tuttleTwins
  return slug
}
